module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-facebook-e36cdd3659df48778dd8f09843860997.png";